import React, { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import TaxCalculator from "./TaxCalculator";
import FinancialYearManager from "./FinancialYearManager";
import SlabManager from "./SlabManager";

const IncomeTaxCalculator = () => {
  const [financialYears, setFinancialYears] = useState(
    JSON.parse(localStorage.getItem("financialYears")) || {
      "FY 25-26": [
        { min: 0, max: 400000, rate: 0 },
        { min: 400001, max: 800000, rate: 5 },
        { min: 800001, max: 1200000, rate: 10 },
        { min: 1200001, max: 1600000, rate: 15 },
        { min: 1600001, max: 2000000, rate: 20 },
        { min: 2000001, max: 2400000, rate: 25 },
        { min: 2400001, max: 10000000000000, rate: 30 },
      ],
      "FY 24-25": [
        { min: 0, max: 300000, rate: 0 },
        { min: 300001, max: 700000, rate: 5 },
        { min: 700001, max: 1000000, rate: 10 },
        { min: 1000001, max: 1200000, rate: 15 },
        { min: 1200001, max: 1500000, rate: 20 },
        { min: 1500001, max: 10000000000000, rate: 30 },
      ],
    }
  );
  const [selectedYear, setSelectedYear] = useState("");
  const [taxableIncome, setTaxableIncome] = useState(
    JSON.parse(localStorage.getItem("taxableIncome")) || 0
  );

  useEffect(() => {
    localStorage.setItem("financialYears", JSON.stringify(financialYears));
    localStorage.setItem("taxableIncome", JSON.stringify(taxableIncome));
  }, [financialYears, taxableIncome]);

  const clearData = () => {
    localStorage.clear();
    setFinancialYears({});
    setTaxableIncome(0);
    setSelectedYear("");
  };
  const clearLocalStorage = () => {
    localStorage.removeItem("financialYears");
    localStorage.removeItem("taxableIncome");
    alert("LocalStorage cleared!");
    window.location.reload();
  };
  return (
    <div className="p-5">
      <h1 className="text-xl font-bold">Income Tax Calculator</h1>
      <Button
        variant="contained"
        color="error"
        onClick={clearLocalStorage}
        sx={{ mt: 3, mb: 3 }}
      >
        Load Defaults
      </Button>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TaxCalculator
            financialYears={financialYears}
            selectedYear={selectedYear}
            taxableIncome={taxableIncome}
            setTaxableIncome={setTaxableIncome}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FinancialYearManager
            financialYears={financialYears}
            setFinancialYears={setFinancialYears}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />
          <SlabManager
            financialYears={financialYears}
            setFinancialYears={setFinancialYears}
            selectedYear={selectedYear}
          />
        </Grid>
      </Grid>
      <Button className="mt-3" variant="contained" color="secondary" onClick={clearData}>
        Clear Data
      </Button>
    </div>
  );
};

export default IncomeTaxCalculator;
